import { render } from "./dcCheckTestItem.vue?vue&type=template&id=4ed1e241"
import script from "./dcCheckTestItem.vue?vue&type=script&lang=js"
export * from "./dcCheckTestItem.vue?vue&type=script&lang=js"

import "./dcCheckTestItem.vue?vue&type=style&index=0&id=4ed1e241&lang=scss"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__